import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/format";
import { TECH_TYPE, ZONE_MATCH, money } from "@/lib/technicians";

const ACTION = { assigned: "Asignada", reassigned: "Reasignada", unassigned: "Sin técnico" };
const Row = ({ label, value, testid }) => <div className="flex justify-between gap-3 text-sm" data-testid={testid}><span className="text-muted-foreground">{label}</span><span className="text-right">{value || "—"}</span></div>;

export const AssignmentCard = ({ wo }) => {
  const { can } = useAuth();
  const a = wo.assignment;
  const r = wo.extensions_internal || {};
  return (
    <section className="fade-up rounded-xl border border-border bg-card/40 p-5" data-testid="wo-assignment-card">
      <h2 className="mb-4 font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Asignación</h2>
      <div className="space-y-1.5">
        <Row label="Zona del servicio" value={wo.zone_name || "Sin zona"} testid="wo-zone-name" />
        {a ? <>
          <Row label="Técnico" value={a.technician_name} testid="wo-assignment-tech" />
          <Row label="Tipo" value={TECH_TYPE[a.technician_type]} testid="wo-assignment-type" />
          <Row label="Especialidad" value={a.specialty_name} testid="wo-assignment-specialty" />
          <Row label="Zona al asignar" value={a.assigned_zone_name ? `${a.assigned_zone_name}${a.zone_match ? ` · ${ZONE_MATCH[a.zone_match]}` : ""}` : "Sin zona"} />
          <Row label="Asignada" value={`${fmtDateTime(a.assigned_at)} · ${a.assigned_by_name || "—"}`} />
        </> : <p className="text-sm text-muted-foreground">Sin técnico asignado.</p>}
        {can("rates.read") && a && (
          <Row label="Tarifa interna" testid="wo-internal-rate"
            value={r.technician_rate_status === "configurada" ? `${money(r.technician_rate_amount, r.technician_rate_currency)} · v${r.technician_rate_version}` : r.technician_rate_label || "Sin tarifa registrada"} />
        )}
      </div>
      {wo.assignment_history?.length > 0 && (
        <div className="mt-4 space-y-2 border-t border-border pt-3" data-testid="wo-assignment-history">
          {[...wo.assignment_history].reverse().map((h, i) => (
            <div key={`${h.assigned_at}-${i}`} className="text-xs">
              <span className="font-medium">{ACTION[h.action]}</span>: {h.technician_name || "—"}{h.previous_technician_name && ` (antes: ${h.previous_technician_name})`}
              <div className="text-muted-foreground">{fmtDateTime(h.assigned_at)} · {h.changed_by_name || "migración"}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
